import React, { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Global } from '@emotion/react';
import { ThemeProvider } from '@emotion/react';
import { globalStyles } from './theme';
import App from './App';
import { ReactQueryDevtools } from 'react-query-devtools';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { WhiteLabelProvider } from './context/WhiteLabelContext';
import WhiteLabelContext from './context/WhiteLabelContext';
import { Box } from './components/shared/layouts';
import LanguageModule from './components/navigation/LanguageModule';
import { MessagebarProvider } from './context/MessagebarContext';
import { UserProvider } from './context/UserContext';
import Loader from "./components/shared/Loader";
import { ContactModalProvider } from "./context/ContactModalContext";
import { withBugsnag } from './utils/bugsnag';
import './utils/svgr';

const myCache = createCache({
  key: 'uwkluis-emotion-cache'
});
myCache.compat = true;

const Root = () => {
  const apiKey = process.env.UWKLUIS_REACT_BUGSNAG_API_KEY;

  const AppWithBugsnag = withBugsnag(AppWithProviders, apiKey);
  return <AppWithBugsnag />;
};

const AppWithProviders = () => (
  <WhiteLabelProvider>
    <Content />
  </WhiteLabelProvider>
);

const Content = () => {
  const { setWhiteLabel, currentTheme } = useContext(WhiteLabelContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const { config } = document.getElementById('react-app').dataset;
    const configData = JSON.parse(atob(config));

    setWhiteLabel(configData);
  }, []);

  return (
    <ThemeProvider theme={currentTheme}>
      <Global styles={() => globalStyles(currentTheme)} />
      <CacheProvider value={myCache}>
        <BrowserRouter>
          <MessagebarProvider>
            <ContactModalProvider>
              <UserProvider>
                <Box color={'primaryFont'}>
                  {isLoading && <Loader fullWidth/>}
                  <LanguageModule setIsLoading={setIsLoading}/>
                  <App />
                </Box>
              </UserProvider>
            </ContactModalProvider>
          </MessagebarProvider>
        </BrowserRouter>
      </CacheProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </ThemeProvider>
  );
};

ReactDOM.render(<Root />, document.getElementById('react-app'));
